import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { Clock } from 'lucide-react';
import dateFnsLocales from '@utils/dateFnsLocales';
import { useGuidedBookingContext } from '@contexts/GuidedBookingContext';
import { Card, CardContent } from '@/components/ui/card';
import { HStack, VStack } from '@/components/ui/layout';

const BookingConfirmationStep: FC = () => {
  const { t, i18n } = useTranslation();
  const { 
    bookingData,
  } = useGuidedBookingContext();


  const appointmentDateTime = bookingData.scheduledAt;
  const formattedDate = appointmentDateTime ? format(new Date(appointmentDateTime), 'EEEE, MMMM d, yyyy', { 
    locale: dateFnsLocales[i18n.language] 
  }) : '';
  const formattedTime = appointmentDateTime ? format(new Date(appointmentDateTime), 'h:mm a', { 
    locale: dateFnsLocales[i18n.language] 
  }) : '';

  return (
    <VStack spacing={6}>
      <VStack spacing={2} align="center">
        <h3 className="text-lg font-medium">
          {t('guidedBooking.confirmation.title')}
        </h3>
      </VStack>

      <Card>
        <CardContent className="p-4">
          <VStack spacing={4}>
            {/* Date & Time */}
            <HStack spacing={3} align="center" justify="start">
              <HStack spacing={0} align="center" justify="center" className="w-8 h-8 bg-primary rounded-full">
                <Clock className="w-4 h-4 text-primary-foreground" />
              </HStack>
              <VStack spacing={0} align="start">
                <div className="font-medium">{formattedDate}</div>
                <div className="text-sm text-gray-600">{formattedTime}</div>
              </VStack>
            </HStack>
          </VStack>
        </CardContent>
      </Card>

    </VStack>
  );
};

export default BookingConfirmationStep;